import React, { useState, useEffect, useRef } from "react";
//import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card } from 'antd'
import DatePicker from 'react-date-picker';

import CorrespondantGetter from '../../Controller/getCorrespondant.js';
import PatientFunctionsGetter from "../../Controller/getSQLPatientFunctions.js";

const AddCorrespondantPopup = (props) => {

  const [research, setResearch] = useState({rpps: ''});
  const [correspondantList, setCorrespondantList] = useState([]);
  const [message, setMessage] = useState("");


  const cancelPopup = () => {
      props.cancelPopup();
  }

  //Function to search correspondant
  const researchCorrespondant = () => {
    CorrespondantGetter.get_Correspondant(research.rpps, props.id_user)
    .then(response => {
      let result
      if (response.given === undefined) {
        result = ["no_result"]
        setMessage(<FormattedMessage id="research.error.rpps" defaultMessage="Error: wrong RPPS number" />)
      }
      else {
        result = [response]
        setMessage("")
      }
      setCorrespondantList(result)
    })
    .catch(e => {
      console.log("error while searching correspondant")
    });
  }

  //Function to save correspondant
  const saveCorrespondant = async (correspondant_data) => {
    let register_result = await PatientFunctionsGetter.update_SQL_patient(props.patient)
    props.cancelPopup();
  }

  // ###### HANDLE CHANGE FUNCTIONS ######
  //Function to handle rpps value
  const handleChangeRPPS = (rpps) => {
      setResearch({ ...research, rpps: rpps.target.value });
  };


  // ###### RENDER FUNCTIONS ######
  const { classes } = props;

  const { Meta } = Card;

  const listingCorrespondants = () => {
      let ret = ""
      if (correspondantList.length !== 0 && correspondantList[0] !== "no_result") {
          return (
              <Row style={{width: "100%", fontSize:"100%"}}>
              Correspondant(s) found: {correspondantList.length}<br/><br/>
              {correspondantList.map(profile_data => {
                  return (
              <span key={profile_data} style={{border: "1px solid black"}} onClick={() => saveCorrespondant(profile_data)}>
                        <FormattedMessage id="research.result.birthname" defaultMessage="Birthname:{lastname}" values={{lastname: profile_data.family}} /><br/>
                        <FormattedMessage id="research.result.firstname" defaultMessage="Firstname:{firstname}" values={{firstname: profile_data.given.join(" ")}} /><br/>
                        <FormattedMessage id="research.result.birthname_used" defaultMessage="Birthname:{lastname}" values={{lastname: profile_data.family}} /><br/>
                        <FormattedMessage id="research.result.firstname_used" defaultMessage="Firstname:{firstname}" values={{firstname: profile_data.given.join(" ")}} /><br/>
                <FormattedMessage id="research.result.RPPS_num" defaultMessage="RPPS number:{rpps}" values={{rpps: profile_data.rpps}} /><br/>
                        <FormattedMessage id="research.result.profession" defaultMessage="Profession:{profession}" values={{profession: profile_data.profession}} /><br/>
                        <FormattedMessage id="research.result.category" defaultMessage="Category:{category}" values={{category: profile_data.category}} /><br/>
                        <FormattedMessage id="research.result.mssantemail" defaultMessage="Mssante mail:{mssantemail}" values={{mssantemail: profile_data.msmail}} /><br/>
                      </span>
                  )
              })}
              </Row>
          )
      }
      else {
          return (
              <Row style={{width: "90%", fontSize:"120%"}}>
                  <h4>{message}</h4>
              </Row>
          )

      }

      return(ret);
  }

  return (
        <div className={classes.popup_background}>
            <div style={{ height: "105%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div className="submit-form" style={{height: "80%"}}>
          <Row className="justify-content-md-center" style = {{ paddingBottom: "10px" }}>
                        <Col style={{ fontWeight: "bold", fontSize:"2.2em"}}>
                                <FormattedMessage id="research.title" defaultMessage="Research" />
                        </Col>
                    </Row>
                    <Row style={{width: "100%", fontSize:"120%"}}>
                        <Col>
                            <label htmlFor="research RPPS_num">
                            <FormattedMessage id="account.RPPS_num" defaultMessage="Numéro RPPS: " />
                            </label>

                            <input
                            type="text"
                            id="correspondant_rpps"
                            required
                            defaultValue=""
                            onChange={handleChangeRPPS}
                            name="correspondant_rpps"
                            style={{width: "100%", border: "1px solid gray"}}
                            />
                        </Col>
                    </Row>
                    <Row style={{margin:"auto", width: "100%", fontSize:"120%"}}>
                        {listingCorrespondants()}
                    </Row>
                    <br/>
                    <center>
                        <button onClick={researchCorrespondant} className="btn btn-success" disabled={!((research.rpps !== ""))}>
                            <FormattedMessage id="button.search" defaultMessage="Research" />
                        </button>
                        <button onClick={cancelPopup} className="btn btn-danger">
                            <FormattedMessage id="button.close" defaultMessage="Close" />
                        </button>
                    </center>
                </div>
            </div>
        </div>

  );
}

export default withStyles(Constants.styles)(AddCorrespondantPopup);
